var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_249",
    "data-name": "Group 249",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 34,
    height: 34,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228",
    transform: "translate(8 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M.276,22.252A.475.475,0,0,1,0,21.759c.008-.666,0-1.333,0-2,0-.348.124-.469.471-.471.325,0,.65,0,1.012,0V19q0-8.495,0-16.99A1.92,1.92,0,0,1,2.21.395,1.846,1.846,0,0,1,3.381,0q4.03,0,8.06,0a1.86,1.86,0,0,1,1.911,1.953q.007,2.488,0,4.975a.283.283,0,0,0,.225.324c.268.087.53.194.789.3A1.269,1.269,0,0,1,15.2,8.7c.008.1.01.2.01.3q0,3.954,0,7.908a.637.637,0,0,0,.259.6.55.55,0,0,0,.845-.383,1.32,1.32,0,0,0,.006-.174q0-5.258,0-10.516V6.3a5.507,5.507,0,0,1-.662-.329,1.8,1.8,0,0,1-.817-1.568c-.006-.688,0-1.376,0-2.064,0-.358.124-.48.483-.485.078,0,.155,0,.257,0V.8c0-.123,0-.246,0-.369A.388.388,0,0,1,15.946,0a.38.38,0,0,1,.368.424c0,.4,0,.8,0,1.195,0,.07.006.141.009.223h.731c0-.241,0-.477,0-.713,0-.253-.009-.508.006-.76a.372.372,0,0,1,.38-.368A.365.365,0,0,1,17.795.4c.007.4,0,.8,0,1.195,0,.078,0,.157,0,.269.132,0,.245-.006.358,0,.235.014.376.134.377.363,0,.825.045,1.655-.024,2.475a1.722,1.722,0,0,1-1.236,1.507c-.067.025-.136.043-.217.069v.286q0,5.193,0,10.385a1.306,1.306,0,0,1-.734,1.276A1.284,1.284,0,0,1,14.481,17.2c-.012-.129-.018-.26-.019-.39q0-3.911,0-7.822c0-.522-.074-.629-.565-.819l-.526-.2V19.288c.33,0,.654,0,.978,0,.359,0,.484.126.485.482,0,.652-.006,1.3,0,1.955a.528.528,0,0,1-.264.525Zm12.337-2.975v-.264q0-8.493,0-16.986A1.148,1.148,0,0,0,11.325.742H3.506A1.136,1.136,0,0,0,2.228,2.008q0,8.515,0,17.03v.239Zm1.476.768H.763v1.449H14.088Zm1.5-17.435c0,.667,0,1.315,0,1.964a.744.744,0,0,0,.045.211,1.11,1.11,0,0,0,1.17.77,1.089,1.089,0,0,0,.987-1.036c.017-.5.007-1,.009-1.5,0-.135,0-.27,0-.413Z",
    transform: "translate(-0.001 0)",
    fill: "#50abf8",
    stroke: "#50abf8",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M61.521,38.29h3.563c.411,0,.527.118.527.532q0,2.075,0,4.15c0,.4-.119.516-.52.517h-7.1c-.409,0-.531-.121-.531-.531q0-2.064,0-4.128c0-.423.118-.539.546-.539h3.52m3.336.755H58.22v3.692h6.637Z",
    transform: "translate(-54.119 -36.067)",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M80.9,157.114c.454,0,.867,0,1.279,0,.314,0,.514.2.434.448a.681.681,0,0,1-.251.307q-2.194,1.579-4.4,3.145c-.194.139-.388.278-.584.416-.229.161-.4.171-.551.035s-.161-.3-.024-.552q.76-1.414,1.522-2.828c.034-.063.066-.127.12-.232h-.595c-.225,0-.449,0-.673,0a.4.4,0,0,1-.45-.26c-.074-.22.053-.355.215-.471L80.48,154.6l1.466-1.048c.241-.172.414-.184.568-.042s.154.307.021.554q-.77,1.434-1.542,2.866c-.026.049-.05.1-.092.183m.149.787-.02-.046a6.108,6.108,0,0,0-.626,0c-.436.045-.6-.313-.4-.668.366-.64.7-1.3,1.053-1.945.027-.051.049-.105.1-.217L78.3,157.073a3.426,3.426,0,0,0,.63.041c.477,0,.633.254.41.669q-.517.965-1.037,1.929c-.028.053-.05.11-.075.165l.03.023,2.8-2",
    transform: "translate(-72.256 -144.506)",
    fill: "#0d292d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStations);
export default __webpack_public_path__ + "static/media/stations.76f62ec8d50ed4a4c84c43d19702a72e.svg";
export { ForwardRef as ReactComponent };